export const typeOptions = ["全部", "电影", "电视剧", "综艺", "短视频"];

export const genreOptions = [
  "全部",
  "剧情",
  "爱情",
  "喜剧",
  "动作",
  "科幻",
  "悬疑",
  "犯罪",
  "古装",
  "武侠",
  "历史",
  "青春",
  "都市",
  "家庭",
  "奇幻",
  "冒险",
  "惊悚",
  "战争",
  "运动",
  "音乐",
  "真人秀",
  "生活",
  "美食",
  "脱口秀",
  "萌宠",
  "知识",
  "纪实",
  "健康",
];

export const regionOptions = ["全部", "大陆", "港台", "欧美", "日韩"];

export const yearOptions = ["全部", "2026", "2025", "2024", "2023"];

export const sortOptions = ["热度", "最新", "评分"];

export const categoryEntries = [
  {
    key: "movie",
    name: "电影",
    type: "电影",
    icon: "ri-film-line",
    desc: "院线大片与口碑佳作",
  },
  {
    key: "tv",
    name: "电视剧",
    type: "电视剧",
    icon: "ri-tv-2-line",
    desc: "热播剧集持续更新",
  },
  {
    key: "variety",
    name: "综艺",
    type: "综艺",
    icon: "ri-mic-line",
    desc: "真人秀与音乐舞台",
  },
  {
    key: "short",
    name: "短视频",
    type: "短视频",
    icon: "ri-play-circle-line",
    desc: "轻量内容随手可看",
  },
];

export const featuredTracks = [
  {
    id: "track-01",
    title: "追剧不迷路",
    desc: "本周口碑更新最快的高分剧集合集，一集入坑停不下来。",
    icon: "ri-fire-line",
    videoIds: ["chengshi-zhiguang", "shenhai-daima", "anxiang-zhuixiong", "sanshi-buhuo"],
  },
  {
    id: "track-02",
    title: "周末电影院",
    desc: "一个人也能看得很爽的口碑电影清单，从科幻到古装一网打尽。",
    icon: "ri-movie-2-line",
    videoIds: ["xingji-xinshi", "niliu-ershang", "changan-huifang", "shanhai-zhiyue"],
  },
  {
    id: "track-03",
    title: "下饭综艺馆",
    desc: "边吃边看的轻松综艺，笑点和治愈感一次拉满。",
    icon: "ri-emotion-happy-line",
    videoIds: ["xiangwang-shangu", "tuokou-erchu", "meishi-xingqiu", "benpao-xiongdituan"],
  },
  {
    id: "track-04",
    title: "碎片时间指南",
    desc: "通勤、排队的几分钟，也能收获一点小惊喜。",
    icon: "ri-time-line",
    videoIds: ["yifenzhong-zhexue", "mengchong-guanchashi", "chengshi-jiepai-riji", "jujia-jianshencao"],
  },
];